/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Snap_To_Shot_ChangesInputs */

const en_options_editor_snap_to_shot_changes = /** @type {(inputs: Options_Editor_Snap_To_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snap to Shot Changes`)
};

const fr_options_editor_snap_to_shot_changes = /** @type {(inputs: Options_Editor_Snap_To_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aligner sur les changements de plan`)
};

const de_options_editor_snap_to_shot_changes = /** @type {(inputs: Options_Editor_Snap_To_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnappschuss-Änderungen`)
};

const it_options_editor_snap_to_shot_changes = /** @type {(inputs: Options_Editor_Snap_To_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggancia alle modifiche di ripresa`)
};

const ru_options_editor_snap_to_shot_changes = /** @type {(inputs: Options_Editor_Snap_To_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменения при мгновенном переходе к кадру`)
};

const es_options_editor_snap_to_shot_changes = /** @type {(inputs: Options_Editor_Snap_To_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios en la toma`)
};

const zh_cn2_options_editor_snap_to_shot_changes = /** @type {(inputs: Options_Editor_Snap_To_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快照到拍摄变化`)
};

const ja_options_editor_snap_to_shot_changes = /** @type {(inputs: Options_Editor_Snap_To_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショットの変更にスナップ`)
};

const hi_options_editor_snap_to_shot_changes = /** @type {(inputs: Options_Editor_Snap_To_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट परिवर्तनों पर स्नैप करें`)
};

const pt_pt2_options_editor_snap_to_shot_changes = /** @type {(inputs: Options_Editor_Snap_To_Shot_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterações de disparo instantâneo`)
};

/**
* | output |
* | --- |
* | "Snap to Shot Changes" |
*
* @param {Options_Editor_Snap_To_Shot_ChangesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_snap_to_shot_changes = /** @type {((inputs?: Options_Editor_Snap_To_Shot_ChangesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Snap_To_Shot_ChangesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_snap_to_shot_changes(inputs)
	if (locale === "de") return de_options_editor_snap_to_shot_changes(inputs)
	if (locale === "it") return it_options_editor_snap_to_shot_changes(inputs)
	if (locale === "ru") return ru_options_editor_snap_to_shot_changes(inputs)
	if (locale === "es") return es_options_editor_snap_to_shot_changes(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_snap_to_shot_changes(inputs)
	if (locale === "ja") return ja_options_editor_snap_to_shot_changes(inputs)
	if (locale === "hi") return hi_options_editor_snap_to_shot_changes(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_snap_to_shot_changes(inputs)
	return en_options_editor_snap_to_shot_changes(inputs)
});